// extracted by mini-css-extract-plugin
module.exports = {"user-image":"UserImage_user-image__uqO1o"};